type StatusFilterValue = 'all' | 'artist_message_needed' | 'waiting_for_client' | 'booked'

interface StatusOverviewProps {
  statusCounts: {
    booked: number
    artist_message_needed: number
    waiting_for_client: number
  }
  onFilterChange?: (filter: StatusFilterValue) => void
  activeFilter?: StatusFilterValue
}

export function StatusOverview({ statusCounts, onFilterChange, activeFilter = 'all' }: StatusOverviewProps) {
  const statuses = [
    {
      key: 'artist_message_needed',
      count: statusCounts.artist_message_needed,
      label: 'Needs Response',
      bgColor: 'bg-red-500 dark:bg-red-600',
      textColor: 'text-white dark:text-white'
    },
    {
      key: 'booked',
      count: statusCounts.booked,
      label: 'Booked',
      bgColor: 'bg-green-500 dark:bg-green-600',
      textColor: 'text-white dark:text-white'
    }
  ]

  return (
    <div className="grid grid-cols-2 md:gap-3 gap-2">
      {statuses.map((status) => (
        <button
          key={status.key}
          onClick={() => {
            if (onFilterChange) {
              const filterValue = activeFilter === status.key ? 'all' : (status.key as StatusFilterValue)
              onFilterChange(filterValue)
            }
          }}
          className={`rounded-lg ${status.bgColor} md:p-3 p-2 flex flex-col items-center justify-center transition-all hover:opacity-80 cursor-pointer active:scale-95`}
        >
          <div className="md:text-2xl text-xl font-bold text-white md:mb-1 mb-0.5">
            {status.count}
          </div>
          <div className={`text-xs font-medium text-center ${status.textColor} leading-tight whitespace-nowrap`}>
            {status.label}
          </div>
        </button>
      ))}
    </div>
  )
}

